import { render, staticRenderFns } from "./VerAlertaVehiculoModal.vue?vue&type=template&id=25d88752&scoped=true&"
import script from "./VerAlertaVehiculoModal.vue?vue&type=script&lang=ts&"
export * from "./VerAlertaVehiculoModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerAlertaVehiculoModal.vue?vue&type=style&index=0&id=25d88752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d88752",
  null
  
)

export default component.exports